// Boxing constants shared by the server sim and the client renderer.
// Logical play-field units; the client scales these to the screen.
//
// The ring is a TALL rectangle (it fills a portrait phone). Slot 0 starts at
// the bottom (+y), slot 1 at the top (-y); a client that is slot 1 flips its
// view 180 degrees so "you" are always at the bottom.

export const RING = {
  /** inner playable area, fighters clamp to this (x: -w/2..w/2, y: -h/2..h/2) */
  w: 280,
  h: 500,
  /** rope/apron thickness drawn outside the playable area */
  border: 32,
};

export const FIGHTER = {
  radius: 22,         // body radius (fighters can't overlap)
  speed: 0.18,        // units per ms at full stick
  accel: 0.0016,
  friction: 0.006,
  reach: 50,          // glove-tip distance from centre at full extension
  hitR: 24,           // how close the foe's centre must be to the glove tip
  punchMs: 240,       // full punch duration
  punchHitAt: 0.42,   // fraction of punchMs where the glove is fully out
  punchSlow: 0.45,    // move speed multiplier while a punch is in flight
  punchCdMs: 110,     // rest between punches
  stunMs: 650,
};

export const MATCH = {
  durationMs: 90_000,
  countdownMs: 3_000,
  koScore: 100,
  hitPoints: 5,
};
